import { TaskPriority as TaskPriorityEnum } from "@common/types/task";
import {
    TaskPriorityLowIcon,
    TaskPriorityMediumIcon,
    TaskPriorityHighIcon,
    TaskPriorityUrgentIcon,
} from "@icons/taskStatuses";

export const TASK_PRIORITY_CONFIG: Record<
    TaskPriorityEnum,
    {
        Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
        label: string;
        className?: string;
    }
> = {
    [TaskPriorityEnum.LOW]: {
        Icon: TaskPriorityLowIcon,
        label: "Low",
        className: undefined,
    },
    [TaskPriorityEnum.MEDIUM]: {
        Icon: TaskPriorityMediumIcon,
        label: "Medium",
        className: "icon-color-revert",
    },
    [TaskPriorityEnum.HIGH]: {
        Icon: TaskPriorityHighIcon,
        label: "High",
        className: "icon-color-revert",
    },
    [TaskPriorityEnum.URGENT]: {
        Icon: TaskPriorityUrgentIcon,
        label: "Urgent",
        className: "icon-color-revert",
    },
};

// Maps the string-literal filter values (from the `taskPriorities` Zod enum in
// common/types/filters/general.ts, which cannot reference TaskPriority directly
// due to a circular dependency) back to the TaskPriority enum in a type-safe way.
export const TASK_PRIORITY_BY_FILTER_VALUE = {
    [TaskPriorityEnum.URGENT]: TaskPriorityEnum.URGENT,
    [TaskPriorityEnum.HIGH]: TaskPriorityEnum.HIGH,
    [TaskPriorityEnum.MEDIUM]: TaskPriorityEnum.MEDIUM,
    [TaskPriorityEnum.LOW]: TaskPriorityEnum.LOW,
} satisfies Record<`${TaskPriorityEnum}`, TaskPriorityEnum>;
